import React, { useMemo } from "react";
import { View } from "react-native";

type Props = {
  width: number;
  height: number;
  radiusTop: number;
  radiusBottom: number;
  children: React.ReactNode;
};

function BorderLayout({
  width,
  height,
  radiusTop,
  radiusBottom,
  children,
}: Props): React.JSX.Element {
  const containerStyle = useMemo(
    () => ({
      width,
      height,
      borderTopLeftRadius: radiusTop,
      borderTopRightRadius: radiusTop,
      borderBottomLeftRadius: radiusBottom,
      borderBottomRightRadius: radiusBottom,
      overflow: "hidden" as const,
    }),
    [width, height, radiusTop, radiusBottom],
  );

  return <View style={containerStyle}>{children}</View>;
}

export default BorderLayout;
